import styled from 'styled-components';
import CloseIconSVG from '@assets/images/icons/legacy/close.svg';

export const ScrollableContainer = styled('div')`
  margin-left: -8px;
  margin-right: -8px;
  overflow: auto;
  height: calc(100% - 42px);
`;

export const Title = styled('h3')`
  margin-top: 0px;
  ${(props) => props.theme.typography.baseStrong}
  color: ${(props) => props.theme.color.white};
`;

export const CloseIcon = styled(CloseIconSVG)`
  fill: ${(props) => props.theme.color.white};
  width: 23px;
  height: 23px;
  cursor: pointer;
`;

export const HeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-top: ${({ theme }) => theme.safeAreaInsetTop};
`;
